
import { Component, input } from '@angular/core'

import { Reference } from '@flowx/designer/modules/ai/types/ai.types'

@Component({
  selector: 'flx-ai-msg-sources',
  imports: [],
  templateUrl: './ai-msg-sources.component.html',
  styleUrl: './ai-msg-sources.component.scss',
})
export class AiMsgSourcesComponent {
  sources = input<Reference[]>([])
}
